const state = {
  notice: {
    type: 'info',
    message: '警告',
    title: '警告'
  }
}

const getters = {
  notice: state => state.notice
}

const actions = {
  showNoticeMsg ({ dispatch }, data) {
    dispatch('setNotice', data)
  },
  setNotice ({ commit }, data) {
    commit('changeNotice', data)
  }
}

const mutations = {
  changeNotice (state, data) {
    state.notice = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notice.js